import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import ids from '../../../QestIds';
import { MeasurementsSection, ResultsSection } from '../../Sections';
import { AsDryMassesSection, AsPreparationSection } from './Sections';

const qestIds = [ids.moistureContent.AS_1289_2_1_1.rev2005];

let As1289_2_1_1_MeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <AsPreparationSection />
    <MeasurementsSection />
    <AsDryMassesSection />
    <ResultsSection />
  </>
);

As1289_2_1_1_MeasuredMoistureContentWorksheet.qestIds = qestIds;

export default As1289_2_1_1_MeasuredMoistureContentWorksheet;
export { As1289_2_1_1_MeasuredMoistureContentWorksheet };
